import React, { useState } from "react";
import { Box, Chip, Grid, Typography } from "@mui/material";
import { MobileCard } from "@ui/components/card";
import { IconText } from "@ui/components/info/IconText";
import { SignalMeter } from "@ui/components/icons/SignalMeter";
import { StatusIndicator } from "@ui/components/status";
import { SMenuTrigger, SMenu } from "@ui/components/menu/SMenu";
import { useTranslation } from "react-i18next";
import { formatUtcToLocalDate, formatUtcToLocalTime, } from "@application/common/helpers/date-util";
import { between } from "@ui/components/style/style";
import { PermissionChecker, Permission } from "@utility/permission-checker";
export const AccessPointCard = ({ row, onClick, onRemove, onNodes, }) => {
    const { t } = useTranslation(["common"]);
    const [menuAnchorEl, setMenuAnchorEl] = useState(null);
    const isActive = row.status === "active";
    const menuItems = [
        ...(PermissionChecker.hasPermission(Permission.USERS_EDIT)
            ? [
                {
                    label: t("common:actions.remove"),
                    // icon: <Trash size={16} />,
                    onClick: () => {
                        onRemove({ id: row.id, name: row.name, deviceId: row.deviceId });
                        setMenuAnchorEl(null);
                    },
                    color: "error",
                },
            ]
            : []),
        {
            label: t("common:actions.nodes"),
            onClick: () => {
                onNodes(row.deviceId);
                setMenuAnchorEl(null);
            },
        },
        ...(PermissionChecker.hasPermission(Permission.ACCESSPOINTS_EDIT)
            ? [
                {
                    label: t("common:actions.settings"),
                    // icon: <Edit size={16} />,
                    onClick: () => {
                        setMenuAnchorEl(null);
                    },
                },
            ]
            : []),
    ];
    return (React.createElement(MobileCard, { onClick: onClick },
        React.createElement(Box, { sx: { display: "flex", alignItems: "center", gap: 1.5 } },
            React.createElement(SignalMeter, { width: 52, height: 44, variant: isActive ? "success" : "warning" }),
            React.createElement(Box, { sx: { minWidth: 0, flex: 1 } },
                React.createElement(Typography, { variant: "subtitle2", noWrap: true }, row.name),
                React.createElement(Typography, { variant: "body2", color: "text.secondary", noWrap: true }, row.deviceId)),
            React.createElement(SMenuTrigger, { onClick: (event) => {
                    event.stopPropagation();
                    setMenuAnchorEl(event.currentTarget);
                }, size: "medium" })),
        React.createElement(Grid, { container: true, spacing: 2 },
            React.createElement(Grid, { size: 6 },
                React.createElement(IconText, { icon: "solar:calendar-linear", text: row.lastUpdate
                        ? formatUtcToLocalDate(row.lastUpdate)
                        : t("common:actions.never") })),
            React.createElement(Grid, { size: 6 },
                React.createElement(IconText, { icon: "solar:clock-circle-linear", text: row.lastUpdate ? formatUtcToLocalTime(row.lastUpdate) : "" }))),
        React.createElement(Box, { sx: Object.assign(Object.assign({}, between), { gap: 1 }) },
            React.createElement(StatusIndicator, { variant: row.status }),
            React.createElement(Chip, { label: `${row.devices} ${row.devices === 1 ? t("common:grid.device") : t("common:grid.devices")}`, size: "small", variant: "soft" })),
        React.createElement(SMenu, { anchorEl: menuAnchorEl, open: Boolean(menuAnchorEl), handleClose: () => setMenuAnchorEl(null), menuItems: menuItems })));
};
